var Whois = Backbone.Model.extend({
    getChannels: function (type, priv) {
        var privatePrefix = '';
        if (priv) {
            privatePrefix = 'private_';
        }
        if (type == 'member') {
            return this.get(privatePrefix + 'prefix_channels_member');
        } else {
            return this.get(privatePrefix + 'prefix_channels_' + type);
        }
    },
    getHostMask: function () {
        var ident = this.get('user_ident_prefix') || '';
        var user = ident + (this.get('user_username') || '');
        var host = this.get('user_host') || '';
        if (user && host) {
            return user + '@' + host;
        } else if (host || user) {
            return host || user;
        }
        return '';
    },
    getSignonDate: function () {
        return new Date(this.getSignonTime());
    },
    getIdleTime: function () {
        return (new Date()).addSeconds(-this.get('idle_secs'));
    },
    getSignonTime: function () {
        return this.get('signon_time') * 1000;
    }
});


module.exports = Whois;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/whois.js
// module id = Jvek
// module chunks = 1